import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/StudyCalculatorImg.webp";
const TITLE = "Konversi IPK ke Sistem Prancis";
const DESCRIPTION =
  "Temukan cara mengkonversi IPK Anda ke sistem Prancis dengan mudah dan akurat. Pelajari detail sistem penilaian universitas Prancis.";
const KEYWORDS =
  "sistem universitas Prancis, konversi IPK universitas, sistem nilai Prancis, nilai sarjana, nilai magister, IPK universitas, Prancis";
const OG_URL = "https://do-calculate.com/calculator/id/gradetofrench";
function GradeToFrench() {
  const [originalValue, setOriginalValue] = useState("");
  const [convertedValue, setConvertedValue] = useState("");
  const [conversionType, setConversionType] = useState("grade");
  const [showResult, setShowResult] = useState(false);
  const [error, setError] = useState(null);
  const gpaToFrenchGrade = (gpa) => {
    if (gpa >= 3.7 && gpa <= 4.0) {
      return "16 – 20";
    } else if (gpa >= 3.5 && gpa < 3.7) {
      return "14 – 15.9";
    } else if (gpa >= 3.0 && gpa < 3.5) {
      return "12 – 13.9";
    } else if (gpa >= 2.5 && gpa < 3.0) {
      return "10 – 11.9";
    } else if (gpa >= 2.0 && gpa < 2.5) {
      return "8 – 9.9";
    } else if (gpa >= 1.5 && gpa < 2.0) {
      return "7 – 7.9";
    } else if (gpa >= 1.0 && gpa < 1.5) {
      return "6 – 6.9";
    } else if (gpa >= 0.5 && gpa < 1.0) {
      return "5 – 5.9";
    } else if (gpa >= 0.0 && gpa < 0.5) {
      return "0 – 4.9";
    } else {
      return "Input tidak valid";
    }
  };
  const calculateGrade = (value) => {
    if (conversionType === "grade") {
      const grade = parseFloat(value);
      if (!isNaN(grade) && grade >= 0 && grade <= 100) {
        return (grade / 5).toFixed(2);
      }
    } else if (conversionType === "gpa") {
      const gpa = parseFloat(value);
      if (!isNaN(gpa) && gpa >= 0 && gpa <= 4) {
        return gpaToFrenchGrade(gpa);
      }
    }
    return "Input tidak valid";
  };
  const handleCalculateClick = () => {
    const converted = calculateGrade(originalValue);
    setConvertedValue(converted);
    setShowResult(true);
    setError(null);
  };
  const handleConversionTypeChange = (newConversionType) => {
    setConversionType(newConversionType);
    setOriginalValue("");
    setConvertedValue("");
    setShowResult(false);
    setError(null);
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Temukan cara mengkonversi IPK Anda (persentase atau IPK) ke sistem Prancis dengan mudah dan akurat. Pelajari detail sistem penilaian universitas Prancis menggunakan alat yang berguna ini.
                </p>
              </div>
              <br />
            </div>
            <hr />
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>
                    Konversi IPK Universitas ke Sistem Prancis
                  </h2>
                </div>
                <hr />
                <div className="form-group">
                  <b>
                    <label>Jenis Nilai:</label>
                  </b>
                  <div>
                    <input
                      type="radio"
                      id="gradeConversion"
                      name="conversionType"
                      value="grade"
                      checked={conversionType === "grade"}
                      onChange={() => handleConversionTypeChange("grade")}
                      className="form-check-input"
                      style={{ marginLeft: "4px" }}
                    />
                    <label
                      htmlFor="gradeConversion"
                      className="form-check-label"
                    >
                      Persentase (100)
                    </label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="gpaConversion"
                      name="conversionType"
                      value="gpa"
                      checked={conversionType === "gpa"}
                      onChange={() => handleConversionTypeChange("gpa")}
                      className="form-check-input"
                      style={{ marginLeft: "4px" }}
                    />
                    <label htmlFor="gpaConversion" className="form-check-label">
                      IPK (4.00)
                    </label>
                  </div>
                </div>
                <br />
                <div>
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label htmlFor="originalValue">
                        {conversionType === "grade"
                          ? "Nilai Persentase:"
                          : "IPK:"}
                      </label>
                    </b>
                    <input
                      type="text"
                      value={originalValue}
                      id="originalValue"
                      onChange={(e) => setOriginalValue(e.target.value)}
                      className="form-control"
                      style={{ width: "200px", marginRight: "4px" }}
                    />
                  </div>
                  <div>
                    <br />
                  </div>
                </div>
                <button
                  className="btn btn-success mt-3"
                  onClick={handleCalculateClick}
                >
                  Hitung
                </button>
                <br />
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-sm-12 col-md-7">
                {error && (
                  <div className="alert alert-warning">
                    <b>
                      <u>Error:</u>
                    </b>{" "}
                    {error}
                  </div>
                )}
                {showResult &&  (
                  <div
                    style={{ fontSize: "15px" }}
                    className="bg-light bg-gradient text-dark"
                  >
                    <div className="p-3 bg-success bg-gradient text-white">
                      <strong>Hasil:</strong>
                    </div>
                    <b>
                      {conversionType === "grade"
                        ? `Nilai Persentase dalam Sistem Prancis: ${convertedValue}`
                        : `IPK dalam Sistem Prancis: ${convertedValue}`}
                    </b>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE}</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Sistem Klasifikasi Nilai Universitas di Prancis
                    </h2>
                  </u>
                  <p>
                    Di Prancis, nilai diklasifikasikan pada skala dari 0 hingga 20, dengan 20 adalah yang terbaik dan 0 adalah yang terburuk. Nilai dapat dibagi sebagai berikut:
                  </p>
                  <table >
                    <thead>
                      <tr className="bmi-header">
                        <th>Nilai Prancis</th>
                        <th>Istilah Prancis Setara</th>
                        <th>Persentase Setara</th>
                        <th>IPK (Skala 4 Poin)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>16 – 20</td>
                        <td>Sangat Baik</td>
                        <td>80-100%</td>
                        <td>3.7-4.0</td>
                      </tr>
                      <tr>
                        <td>14 – 15.9</td>
                        <td>Baik Sekali</td>
                        <td>70-79%</td>
                        <td>3.5-3.6</td>
                      </tr>
                      <tr>
                        <td>12 – 13.9</td>
                        <td>Baik</td>
                        <td>60-69%</td>
                        <td>3.0-3.4</td>
                      </tr>
                      <tr>
                        <td>10 – 11.9</td>
                        <td>Cukup</td>
                        <td>50-59%</td>
                        <td>2.5-2.9</td>
                      </tr>
                      <tr>
                        <td>0 – 9.9</td>
                        <td>Gagal</td>
                        <td>0-49%</td>
                        <td>0-2.4</td>
                      </tr>
                    </tbody>
                  </table>
                  <p>
                    Informasi ini membantu memahami cara mengkonversi nilai ke sistem Prancis dan mengetahui persentase setaranya.
                  </p>
                  <b className="text-primary">
                    <span>Contoh: </span>
                    Jika Anda memiliki IPK 3.0 pada skala 4.0, Anda dapat mengkonversinya ke sistem Prancis menggunakan alat di atas dan Anda akan mendapatkan hasil yang setara.
                  </b>
                  <p>
                    Alat ini sangat berguna bagi mahasiswa internasional yang ingin melanjutkan studi di Prancis atau melamar pekerjaan yang membutuhkan IPK tertentu.
                  </p>
                  <div>
                    <p>
                      Prancis adalah negara yang maju secara ilmiah, dengan banyak universitas ternama yang menjadi tujuan mahasiswa dari seluruh dunia.
                    </p>
                    <p className="alert alert-info">
                      Di Prancis terdapat banyak universitas yang terakreditasi secara global, dan sistem studi di universitas Prancis dikenal dengan ketelitian ilmiah dan kebaruan kurikulum. Biaya studi di Prancis juga relatif terjangkau dibandingkan dengan negara-negara Eropa lainnya dan Amerika Serikat.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default GradeToFrench;